import React from "react";
import MoreHelpPanel from "../MoreHelpPanel";

const ArticleNotFound = () => (
  <div className="review-section">
    <div className="detailsbox container">
      <div className="article-title">
        <div className="title">
          The article you’re looking for has not been found
        </div>
        <div className="fs24">
          Please try selecting the link in the email again.
        </div>
      </div>
      <MoreHelpPanel />
    </div>
  </div>
);

export default ArticleNotFound;
